var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ev-config-panel',{staticClass:"solver-page"})
}
var staticRenderFns = []

export { render, staticRenderFns }